import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import { Star } from 'iconsax-react'
import useFavorites from '@SonarCX/hooks/useFavorites'

import Tooltip from '../Tooltip'

import { track } from '@SonarCX/lib/mixpanel'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useStyles from './styles'

interface FavoriteButtonProps {
  isFavorite: boolean
  itemId: string
  type: APIFavorite['type']
  additionalClass?: string
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  isFavorite = false,
  additionalClass = '',
  itemId,
  type,
  ...rest
}) => {
  const { user: me } = useEnvironment()
  const { handleFavoriteClick } = useFavorites()
  const theme = useTheme()
  const classes = useStyles()

  const handleOnClick = async e => {
    e.stopPropagation()
    track(isFavorite ? 'REMOVE_FAVORITE' : 'ADD_FAVORITE', { itemId, type })
    await handleFavoriteClick(me.id, isFavorite, itemId, type)
  }

  if (!me || !itemId) return null

  return (
    <Tooltip title={isFavorite ? 'Remove from favorites' : 'Mark as favorite'}>
      <Star
        className={clsx(classes.root, additionalClass)}
        variant={isFavorite ? 'Bold' : 'Linear'}
        color={isFavorite ? theme.palette.primary.main : theme.palette.border}
        onClick={handleOnClick}
        {...rest}
      />
    </Tooltip>
  )
}
export default FavoriteButton
